export default "__VITE_ASSET__OzDre9yZ__"